import React from 'react';
import { Avatar } from '@mui/material';
import PropTypes from 'prop-types';

AvatarIcon.propTypes = {
  name: PropTypes.string,
  sx: PropTypes.object,
  size: PropTypes.number,
};

function AvatarIcon({ name, sx, size = 32 }) {
  function stringAvatar(name) {
    return {
      sx: {
        mr: 0,
        width: size,
        height: size,
        ...sx,
      },
      children: `${name.split(' ')[0][0]}`,
    };
  }

  return (
    <div>
      <Avatar {...stringAvatar(`${name}`)} />
    </div>
  );
}

export default AvatarIcon;
